
import Api2Talk from "../api2talk";

const PATH = '/webchat';

const create = async (input) => { 
  try {
    const response = await Api2Talk.post(PATH, input);
    return response.data;
  } catch (err) {
    throw err;
  }
};

const update = async (input) => { 
  try {
    const response = await Api2Talk.put(PATH, input);
    return response.data;
  } catch (err) {
    throw err;
  }
};

const getAllPaginate = async (page) => {
  try {
    const response = await Api2Talk.get(`${PATH}/paginate?page=${page}`);
    return response.data;
  } catch (err) {
    throw err;
  }
}

const getById = async (id) => {
  try {
    const response = await Api2Talk.get(`${PATH}/${id}`);
    return response.data;
  } catch (err) {
    throw err;
  }
}

const deleteById = async (id) => {
  try {
    const response = await Api2Talk.delete(`${PATH}/${id}`);
    return response.data;
  } catch (err) {
    throw err;
  }
}

// ===== Identity Verification (HMAC) — secret por webchat =====

const getIdentitySecret = async (id) => {
  try {
    const response = await Api2Talk.get(`${PATH}/${id}/identity-secret`);
    return response.data;
  } catch (err) {
    throw err;
  }
}

const generateIdentitySecret = async (id) => {
  try {
    const response = await Api2Talk.post(`${PATH}/${id}/identity-secret`);
    return response.data;
  } catch (err) {
    throw err;
  }
}

const deleteIdentitySecret = async (id) => {
  try {
    const response = await Api2Talk.delete(`${PATH}/${id}/identity-secret`);
    return response.data;
  } catch (err) {
    throw err;
  }
}

export {
  create,
  getAllPaginate,
  deleteById,
  getById,
  update,
  getIdentitySecret,
  generateIdentitySecret,
  deleteIdentitySecret
}